/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: ForgotPassword
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 20Aug2022 craig File created.
 \******************************************************************************/
import React, {useState} from "react";
import "../Forms.css";
import "../../../../App.css";
import * as Yup from 'yup';
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {Formik, ErrorMessage} from 'formik';
import {getDataPost} from "../../../../models/data/Data";
import {IOutcome} from "../../../../models/request/Outcome";

export const ForgotPassword: React.FC = () => {
    //const navigate = useNavigate();

    const [forgotPasswordMsg, setForgotPasswordMsg] = useState<string | undefined>("");

    const schema = Yup.object().shape({
        emailaddress: Yup.string().required().email(),
    });

    const buildForm = () => {
        return (
            <Formik
                validationSchema={schema}
                onSubmit={ (values) => {
                    const data = `${encodeURIComponent("emailaddress")}=${encodeURIComponent(values.emailaddress)}`
                    const forgotPasswordURL = process.env.REACT_APP_API_URL + "/api/form/forgot";
                    getDataPost(forgotPasswordURL, data).then(response => {
                        const outcome: IOutcome = response;
                        setForgotPasswordMsg(outcome.RequestMsg);
                    })
                }}
                initialValues={{
                    emailaddress: '',
                }}
                validateOnChange={false}
                validateOnBlur={false}>
                {({
                      handleSubmit,
                      handleChange,
                      resetForm,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                      isSubmitting,
                  }) => (
                    <Form className="form-layout" onSubmit={handleSubmit} noValidate={true}>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="formBasicEmail">
                                <Form.Label>Email *</Form.Label>
                                <Form.Control required
                                              name={"emailaddress"}
                                              className="text-mid-width"
                                              type="email"
                                              placeholder="Enter email"
                                              isValid={touched.emailaddress && !errors.emailaddress}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter your email address.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid email address
                                </Form.Control.Feedback>
                                <ErrorMessage name={"emailaddress"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Button variant="primary" className="btn-submit" type="submit" >
                            Reset Password
                        </Button>
                    </Form>
                )}
            </Formik>
        )
    }

    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1 className="page-title">Forgot Password</h1>
                    <div className={"error-message"}>{forgotPasswordMsg}</div>
                </Col>
            </Row>
            {buildForm()}
        </Container>
    );

}


